/* eslint-disable */
// @ts-nocheck
import React, { useEffect, useState } from 'react';
import axios from 'axios';

const DiscountBandGroupStats = ({ formValues, intl }: any) => {
  const [stats, setStats] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const discount_bands_id = formValues?.discount_bands_id;
  const passengers_groups_id = formValues?.passengers_groups_id;

  useEffect(() => {
    if (discount_bands_id && passengers_groups_id) {
      const fetchStats = async () => {
        setLoading(true);
        try {
          let authData: any = null;
          const localAuthData = localStorage.getItem('authData');
          if (localAuthData) {
            const parsedAuthData = JSON.parse(localAuthData);
            authData = parsedAuthData.userToken;
          }

          const res = await axios.get(
            `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/fare_media_policy_capping/fare_media_policy_capping_statistics/discount-band-group-stats?discount_bands_id=${discount_bands_id}&passengers_groups_id=${passengers_groups_id}`,
            {
              headers: {
                'access-token': authData?.['access-token'] || authData?.access_token,
                'uid': authData?.uid,
                'client': authData?.client,
                'Authorization': `Bearer ${localStorage.getItem('dashboard_token')}`
              }
            }
          );
          setStats(res.data.data);
        } catch (error) {
          console.error("Failed to fetch stats", error);
        } finally {
          setLoading(false);
        }
      };
      fetchStats();
    } else {
      setStats(null);
    }
  }, [discount_bands_id, passengers_groups_id]);

  if (!discount_bands_id || !passengers_groups_id) return null;

  return (
    <div style={{ marginTop: '10px', padding: '10px', backgroundColor: '#e6f7ff', border: '1px solid #91d5ff', borderRadius: '4px', fontSize: '0.85rem', color: '#0050b3' }}>
      <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>{intl?.formatMessage({ id: 'Analysis' }) || 'Analysis'}:</div>
      {loading ? (
        <div>{intl?.formatMessage({ id: 'Loading' }) || 'Loading...'}</div>
      ) : stats ? (
        <>
          <div>{intl?.formatMessage({ id: 'TotalUsersInGroup' }) || 'Total Users in Group'}: <strong>{stats.user_count}</strong></div>
          <div>{intl?.formatMessage({ id: 'TotalFareMediaInGroup' }) || 'Total Fare Media in Group'}: <strong>{stats.fare_media_count}</strong></div>
          {stats.is_fare_product && (
            <div>
              {intl?.formatMessage({ id: 'UniqueFareMediaWithOffer' }) || 'Count of Cards Purchasing this Offer'}: <strong>{stats.unique_fare_media_count}</strong> 
              {' '}
              ({stats.fare_media_count > 0 ? ((stats.unique_fare_media_count / stats.fare_media_count) * 100).toFixed(2) : 0}%)
            </div>
          )}
        </>
      ) : null}
    </div>
  );
};

export default DiscountBandGroupStats;
